import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { Evaluation } from '../models/evaluation/evaluation.model';
import { Roles } from '../models/enums';

@Injectable({ providedIn: 'root'})
export class CodingEndpoint extends EndpointFactory {

  private readonly _codingUrl: string = '/api/coding';
  private readonly _codingUIElements: string = '/api/coding/uielements';
  private readonly _codingSubmissionUrl: string = '/api/coding/submission';
  private readonly _recommendEvaluationForReviewUrl: string = '/api/coding/evaluation/recommendforreview';
  private readonly _recommendEvaluationForAdjudicationUrl: string = '/api/coding/evaluation/recommendforadjudication';

  get codingUrl() { return this.configurations.baseUrl + this._codingUrl; }
  get codingUIElements() { return this.configurations.baseUrl + this._codingUIElements; }
  get protocolSumissionUrl() { return this.configurations.baseUrl + this._codingSubmissionUrl; }
  get recommendEvaluationForReviewUrl() { return this.configurations.baseUrl + this._recommendEvaluationForReviewUrl; }
  get recommendEvaluationForAdjudicationUrl() { return this.configurations.baseUrl + this._recommendEvaluationForAdjudicationUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getCodingUIElementsEndpoint<T>(protocolId?: number): Observable<T> {
    const endpointUrl = protocolId ? `${this.codingUIElements}/${protocolId}` : this.codingUIElements;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }

  getNewCodingSubmissionEndpoint<T>(submission: Evaluation, activeTeam: number): Observable<T> {
    return this.http.post<T>(this.protocolSumissionUrl + `/${activeTeam}`, JSON.stringify(submission), this.getRequestHeaders());
  }

  postRecommendEvaluationForReview<T>(currentEvaluationId: number): Observable<T> {
    return this.http.post<T>(this.recommendEvaluationForReviewUrl, JSON.stringify(currentEvaluationId), this.getRequestHeaders());
  }

  postRecommendEvaluationForAdjudication<T>(currentEvaluationId: number): Observable<T> {
    return this.http.post<T>(this.recommendEvaluationForAdjudicationUrl, JSON.stringify(currentEvaluationId), this.getRequestHeaders());
  }
}
